import {snakeCaseToCamelCase} from './snakeCaseToCamelCase';
import {transformObjectKeys} from './transformObjectKeys';

export const toUIObject = (obj) =>
  transformObjectKeys(snakeCaseToCamelCase, obj);
